export const siteConstants = {
  DEFAULT_TITLE: "Hong Bao Media: Media Training & Executive Coaching",
  TITLE_TEMPLATE: "%s | Hong Bao Media",
  ERROR_MSG_DEFAULT: "A problem is encountered while processing your request, please try again. Please use LiveChat, email us at admin@hongbaomedia.com, or call (65) 6223 2249 if problem persists.",
  ERROR_MSG_INVALID_REPORT: "Uploaded file is not a valid Clifton Strengths 34 report.",
  ERROR_MSG_CLAIM_THINKIFIC_DISCOUNT_CODE_FAILED: "Unable to obtain Thinkific discount code. Please use LiveChat, email us at admin@hongbaomedia.com, or call (65) 6223 2249 to report this problem.",
}